import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { obterMeuParceiro, salvarMeuParceiro, skillsSugeridas } from "../services/api";
import { HorariosParceiro, AulasDoParceiro } from "../components/ParceiroAulas";

// 🎓 PAINEL DO PARCEIRO DE CAPACITAÇÃO (17/10/2026). Etapa 1: a ficha (o que aparece na vitrine para o candidato)
// e a situação da aprovação. Nas próximas etapas entram os horários da aula grátis, os pedidos e as aulas.
const inputCls = "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30";
// Vantagens que o eaiRH oferece ao parceiro escolher (18/10/2026). "detalhe" = pede um complemento curto.
// Nada que prometa emprego (regra dos parceiros: curso nunca associado a vaga).
const VANTAGENS = [
  { rotulo: "Desconto na matrícula", detalhe: "Quanto? Ex.: 15%" },
  { rotulo: "Desconto nas mensalidades", detalhe: "Quanto e por quanto tempo? Ex.: 10% nos 3 primeiros meses" },
  { rotulo: "Isenção da taxa de matrícula" },
  { rotulo: "Material didático grátis" },
  { rotulo: "Teste de nivelamento grátis" },
  { rotulo: "Segunda aula experimental grátis" },
  { rotulo: "Aula em grupo grátis por um mês" },
  { rotulo: "Certificado de participação" },
];

export default function ParceiroPainelPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [ficha, setFicha] = useState(null);
  const [erro, setErro] = useState("");
  const [salvo, setSalvo] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [sugestoes, setSugestoes] = useState([]);
  const [novaSkill, setNovaSkill] = useState("");

  useEffect(() => {
    if (!user) { navigate("/entrar?redirect=/parceiro"); return; }
    if (user.tipo !== 3) { navigate("/"); return; }
    document.title = "Painel do parceiro · eaiRH";
    obterMeuParceiro().then(setFicha).catch((e) => setErro(e.message));
    skillsSugeridas().then((l) => setSugestoes((l || []).map((x) => x.nome))).catch(() => {});
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!user || user.tipo !== 3) return null;
  const muda = (k) => (e) => { setSalvo(false); setFicha((f) => ({ ...f, [k]: e.target.value })); };
  const addSkill = (s) => {
    const t = (s || "").trim();
    if (!t || ficha.skills.some((x) => x.toLowerCase() === t.toLowerCase()) || ficha.skills.length >= 15) return;
    setSalvo(false); setFicha((f) => ({ ...f, skills: [...f.skills, t] })); setNovaSkill("");
  };
  const salvar = async (e) => {
    e.preventDefault(); setErro(""); setSalvando(true);
    try { setFicha(await salvarMeuParceiro(ficha)); setSalvo(true); }
    catch (er) { setErro(er.message); }
    setSalvando(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <h1 className="text-2xl font-bold text-text">Painel do parceiro</h1>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {!ficha ? <p className="mt-4 text-sm text-gray-500">Carregando…</p> : (
          <>
            {ficha.aprovado ? (
              <div className="mt-4 rounded-2xl bg-green-50 border border-green-200 p-4 text-sm">
                <b className="text-green-800">✅ Cadastro aprovado.</b> Sua ficha aparece para os candidatos que buscam as suas skills.
              </div>
            ) : (
              <div className="mt-4 rounded-2xl bg-amber-50 border border-amber-200 p-4 text-sm">
                <b className="text-amber-800">⏳ Aguardando aprovação.</b> Complete a ficha abaixo: é ela que a nossa equipe revisa e que os
                candidatos vão ver. Você recebe um e-mail quando for aprovado.
              </div>
            )}

            <form onSubmit={salvar} className="mt-6 bg-white rounded-2xl shadow-sm p-5 space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <label className="text-xs text-gray-600">Nome na vitrine
                  <input className={`${inputCls} mt-1`} value={ficha.nomeExibicao || ""} onChange={muda("nomeExibicao")} maxLength={120} required />
                </label>
                <label className="text-xs text-gray-600">Você é
                  <select className={`${inputCls} mt-1`} value={ficha.formato} onChange={muda("formato")}>
                    <option value="professor">Professor(a) autônomo(a)</option>
                    <option value="escola">Escola</option>
                  </select>
                </label>
                <label className="text-xs text-gray-600">Cidade
                  <input className={`${inputCls} mt-1`} value={ficha.cidade || ""} onChange={muda("cidade")} maxLength={80} placeholder="Ex.: São Paulo/SP" />
                </label>
                <label className="text-xs text-gray-600">Suas aulas são
                  <select className={`${inputCls} mt-1`} value={ficha.modalidade} onChange={muda("modalidade")}>
                    <option value="online">Online</option>
                    <option value="presencial">Presenciais</option>
                    <option value="ambos">Online e presenciais</option>
                  </select>
                </label>
              </div>

              <div>
                <div className="text-xs text-gray-600">Skills que você ensina <span className="text-gray-400">(até 15)</span></div>
                <div className="flex flex-wrap gap-1.5 mt-1">
                  {ficha.skills.map((s) => (
                    <span key={s} className="inline-flex items-center gap-1 rounded-full bg-sky-100 text-sky-900 text-xs font-semibold px-2.5 py-1">
                      {s}
                      <button type="button" aria-label={`Tirar ${s}`} onClick={() => { setSalvo(false); setFicha((f) => ({ ...f, skills: f.skills.filter((x) => x !== s) })); }}>×</button>
                    </span>
                  ))}
                </div>
                <div className="flex gap-2 mt-2">
                  <input list="skills-vagas" className={inputCls} value={novaSkill} onChange={(e) => setNovaSkill(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addSkill(novaSkill); } }} placeholder="Ex.: Excel, Inglês, Power BI" />
                  <datalist id="skills-vagas">{sugestoes.map((s) => <option key={s} value={s} />)}</datalist>
                  <button type="button" onClick={() => addSkill(novaSkill)} className="shrink-0 bg-slate-100 hover:bg-slate-200 font-bold rounded-lg px-3 text-sm">Adicionar</button>
                </div>
                <p className="text-[11px] text-gray-400 mt-1">As sugestões são as skills mais pedidas nas vagas e nos currículos do eaiRH.</p>
              </div>

              <label className="block text-xs text-gray-600">Sobre você / a escola
                <textarea className={`${inputCls} mt-1`} rows={4} maxLength={1500} value={ficha.sobre || ""} onChange={muda("sobre")}
                  placeholder="Experiência, método, para quem são as aulas…" />
              </label>
              {/* 18/10/2026 (Nelson: "o campo vantagem precisa ser selecionável, nós oferecemos o tipo de vantagem") */}
              {(() => {
                const atual = ficha.vantagem || "";
                const tipo = VANTAGENS.find((v) => atual === v.rotulo || atual.startsWith(v.rotulo + ":"))?.rotulo || (atual ? "outra" : "");
                const detalhe = tipo && tipo !== "outra" && atual.startsWith(tipo + ":") ? atual.slice(tipo.length + 1).trim() : "";
                const pedeDetalhe = VANTAGENS.find((v) => v.rotulo === tipo)?.detalhe;
                const grava = (t, d) => { setSalvo(false); setFicha((f) => ({ ...f, vantagem: !t ? "" : d ? `${t}: ${d}` : t })); };
                return (
                  <div className="block text-xs text-gray-600">O que você oferece a quem vem pelo eaiRH
                    <select className={`${inputCls} mt-1`} value={tipo === "outra" ? "" : tipo} onChange={(ev) => grava(ev.target.value, "")}>
                      <option value="">Só a 1ª aula grátis (já vale para todos)</option>
                      {VANTAGENS.map((v) => <option key={v.rotulo} value={v.rotulo}>{v.rotulo}</option>)}
                    </select>
                    {pedeDetalhe && (
                      <input className={`${inputCls} mt-2`} maxLength={60} value={detalhe} onChange={(ev) => grava(tipo, ev.target.value)}
                        placeholder={pedeDetalhe} />
                    )}
                  </div>
                );
              })()}
              <div className="grid sm:grid-cols-2 gap-4">
                <label className="text-xs text-gray-600">Site
                  <input className={`${inputCls} mt-1`} maxLength={200} value={ficha.site || ""} onChange={muda("site")} placeholder="https://" />
                </label>
                <label className="text-xs text-gray-600">Instagram
                  <input className={`${inputCls} mt-1`} maxLength={60} value={ficha.instagram || ""} onChange={muda("instagram")} placeholder="@seuperfil" />
                </label>
              </div>

              <div className="flex items-center gap-3">
                <button disabled={salvando} className="bg-accent text-white font-bold rounded-lg px-5 py-2 disabled:opacity-60">{salvando ? "Salvando…" : "Salvar ficha"}</button>
                {salvo && <span className="text-sm text-green-700">✓ Salvo</span>}
              </div>
            </form>

            <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
              <h2 className="font-bold text-text text-lg">Pedidos e aulas</h2>
              <div className="mt-2"><AulasDoParceiro /></div>
            </section>
            <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
              <h2 className="font-bold text-text text-lg">Horários da aula grátis</h2>
              <div className="mt-2"><HorariosParceiro /></div>
              {!ficha.aprovado && <p className="text-xs text-amber-700 mt-2">Você já pode abrir horários; eles aparecem para os candidatos depois da aprovação.</p>}
            </section>
          </>
        )}
      </main>
    </div>
  );
}
